export const SAFE_AREA = 24;
export const MIN_SIZE = {
  width: 550,
  height: 350,
  initialHeight: 400,
} as const;

export const MIN_CONTAINER_WIDTH = 240;

export const LOCALSTORAGE_KEY = "react-scan-widget-settings-v2";
export const LOCALSTORAGE_COLLAPSED_KEY = "react-scan-widget-collapsed-v1";
export const LOCALSTORAGE_LAST_VIEW_KEY = "react-scan-widget-last-view-v1";
